import "./Spinner.css";

import type { SizeProp } from "../components";

export interface SpinnerProps {
  invert?: boolean;
  size?: Extract<SizeProp, "xs" | "sm" | "md" | "lg">;
}

export function Spinner({ invert, size }: SpinnerProps) {
  return (
    <div
      className="Spinner"
      data-invert={invert}
      data-size={size}
      role="progressbar"
    >
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
